import React from 'react';
import { Col, Div, Row } from '../../../../grid';
import { Image } from '../../../../Image';
import ImageSlider from '../../../../ImageSlider/ImageSlider';
import PackImageSelector from '../../../Item/PackImageSelector';

const RenderSingleImage = ({
  imageSingle,
  hasPluralImage,
  productPageMaxImageHeight,
  productPageXtraProduct,
  smallScreen,
}) => {
  if (!imageSingle) {
    return null;
  }
  if (smallScreen) {
    return (
      <Div textCenter>
        <Image maxHeight="200px" imageHeight="200px" name={imageSingle} />
      </Div>
    );
  }
  return (
    <Col xs={hasPluralImage ? 6 : 12} aligner textCenter>
      <Image name={imageSingle} maxHeight={productPageMaxImageHeight ? `${productPageMaxImageHeight}` : productPageXtraProduct ? '200px' : '350px'} className={!hasPluralImage && 'bucketAnimation'} />
    </Col>
  );
};

const RenderPluralImage = ({
  imagePlural,
  productPageMaxImageHeight,
  smallScreen,
}) => {
  if (!imagePlural) {
    return null;
  }
  if (smallScreen) {
    return (
      <Div textCenter>
        <Image maxHeight="200px" imageHeight="200px" name={imagePlural} />
      </Div>
    );
  }
  return (
    <Col xs={6} aligner textCenter>
      <Image name={imagePlural} maxHeight={productPageMaxImageHeight ? `${productPageMaxImageHeight}` : '350px'} className="bucketAnimation" />
    </Col>
  );
};

const RenderImages = ({
  imageSingle,
  singleWidth,
  imagePlural,
  pluralWidth,
  productTypePack,
  packImages,
  imageDescription,
  imageMaxHeight,
  productPageMaxImageHeight,
  productPageXtraProduct,
  smallScreen,
}) => {
  if (productTypePack) {
    return (
      <Div textCenter>
        {packImages && packImages.length > 0 && (
          <PackImageSelector imageDescription={imageDescription} imageMaxHeight={imageMaxHeight} packImages={packImages} productPage />
        )}
      </Div>
    );
  }
  if (!imageSingle) {
    return <RenderPluralImage imagePlural={imagePlural} pluralWidth={pluralWidth} smallScreen={smallScreen} />;
  }
  if (!imagePlural) {
    return <RenderSingleImage imageSingle={imageSingle} singleWidth={singleWidth} hasPluralImage={Boolean(imagePlural)} smallScreen={smallScreen} />;
  }
  if (smallScreen) {
    return (
      <ImageSlider className="bucketAnimation">
        <RenderSingleImage imageSingle={imageSingle} singleWidth={singleWidth} hasPluralImage={Boolean(imagePlural)} smallScreen={smallScreen} />
        <RenderPluralImage imagePlural={imagePlural} pluralWidth={pluralWidth} smallScreen={smallScreen} />
      </ImageSlider>
    );
  }
  return (
    <Row>
      <RenderSingleImage imageSingle={imageSingle} singleWidth={singleWidth} productPageMaxImageHeight={productPageMaxImageHeight} productPageXtraProduct={productPageXtraProduct} hasPluralImage={Boolean(imagePlural)} />
      <RenderPluralImage imagePlural={imagePlural} pluralWidth={pluralWidth} productPageMaxImageHeight={productPageMaxImageHeight} />
    </Row>
  );
};

export default RenderImages;
